export class Config {
  static BACKEND_URL =
    process.env.VUE_APP_BACKEND_URL || "http://localhost:1337";
  static REDIRECT_URI =
    process.env.VUE_APP_REDIRECT_URI || "http://localhost:3001/loader";
  static TITLE = process.env.VUE_APP_TITLE || "inboxmaster dev";
  static PORT = process.env.VUE_APP_PORT || 3001;
  static GOOGLE_CLIENT_ID =
    process.env.VUE_APP_GOOGLE_CLIENT_ID || "your-google-client-id";
  static STRIPE_PAYMENT_LINK =
    process.env.VUE_APP_STRIPE_PAYMENT_LINK || "sum_link";
  static MONTHLY_PRICE = process.env.VUE_APP_MONTHLY_PRICE || "4.90";
  static MIXPANEL_TOKEN = process.env.VUE_APP_MIXPANEL_TOKEN || "token";
  static MIXPANEL_API_HOST =
    process.env.VUE_APP_MIXPANEL_API_HOST || "https://api.mixpanel.com";
}
